import React from "react";

const LoadingOverlay: React.FC<{ loading: boolean, className?: string }> = ({
  children,
  loading,
  className = "",
}) => {
  return (
    <div className={`relative ${className}`}>
      {loading && (
        <div className="absolute inset-0 bg-white bg-opacity-70 flex justify-center items-center z-10 gap-2">
          <img src="/loading.gif" width="20" alt="loading" />
          Loading...
        </div>
      )}
      {children}
    </div>
  );
};

export default LoadingOverlay;
